import styled from "styled-components";
import {Styles} from "../Styles/Styles";
import {useEffect, useState} from "react";
import {API} from "../API/api";
import useGlobalSettings from "../Provider/useGlobalSettings";
import {ViewTypes} from "../Provider/useGlobalSettingsContextProvider";
import {useNavigate} from "react-router-dom";

type EmailListItem = {
    id: string;
    timestamp: Date;
    from: string;
    subject: string;
};

const MyStyles = {
    eMail: {
        FrameHeader: styled( Styles.eMail.Header )`
            &:hover {
                background-color: rgba(255, 255, 255, 0.5) !important;
                cursor: pointer;
            }
        `,
        Header: {
            TimeStamp: styled.div`
                width: 100%;
                text-align: right;
                font-size: small;
                color: white;
            `,
            MetaSourceFrame: styled.div`
                margin-top: 0px;
                color: white;
                display: grid;
                grid-template-columns: 50px calc(100% - 60px);
            `,
            From: styled.div``,
            To: styled.div``,
            Subject: styled.div`
                font-size: larger;
                padding-top: 3px;
                display: grid;
                grid-template-columns: 110px calc(100% - 120px);`,
        }
    }
}

const ListOfEmail = ({ data }:{data: EmailListItem}) => {

    const { Mails } = useGlobalSettings();
    const navigate = useNavigate();

    const handles = {
        click: () => {
            void navigate( `/mail/${data.id}` );
        }
    }

    return <Styles.eMail.Frame>
        <MyStyles.eMail.FrameHeader onClick={ handles.click } isNew={ ! Mails.readed.includes( data.id ) } >
            <MyStyles.eMail.Header.TimeStamp>{ new Date(data.timestamp)?.toLocaleString("de-DE",{month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'}) }</MyStyles.eMail.Header.TimeStamp>
            <MyStyles.eMail.Header.MetaSourceFrame>
                <MyStyles.eMail.Header.From>Von:</MyStyles.eMail.Header.From>
                <MyStyles.eMail.Header.From>{ data.from }</MyStyles.eMail.Header.From>
            </MyStyles.eMail.Header.MetaSourceFrame>

            <MyStyles.eMail.Header.Subject>
                <div>Betreff:</div>
                <div>{ data.subject }</div>
            </MyStyles.eMail.Header.Subject>
        </MyStyles.eMail.FrameHeader>
    </Styles.eMail.Frame>
}

export const ListOfEmails = () => {

    const { Actions, activeMission, Mails } = useGlobalSettings();
    const [list, setList] = useState<EmailListItem[]>([]);

    useEffect( () => {
        Actions.Fetching.start( 'ListOfEmails' );
        const timer = setTimeout( () =>
            API.getListOfEMails( activeMission )
                .then( (res: {data: EmailListItem[]}) =>
                    setList(
                        // @ts-ignore
                        res.data.sort( (a,b ) => b.timestamp.localeCompare( a.timestamp ) )
                    ))
                .catch( err => console.error(err) )
                .finally( () => Actions.Fetching.stop( 'ListOfEmails' ) ), 2000 );
        return () => clearTimeout( timer );
    },[null, Mails.new])

    if( ! list )
        return null

    return <div>{
        list.map( (email, index) => <ListOfEmail key={index} data={email} /> )
    }</div>
}